import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {environment} from "../../environments/environment";
import {SystemSettingsService} from "../service/system-settings.service";


@Directive({
  selector: '[showToolId]',
  standalone: true,
})
export class ShowToolId {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private vcRef: ViewContainerRef,
    private systemSettingsService: SystemSettingsService,
  ) {
    this.fetchSearch4toolId();
  }

  async fetchSearch4toolId() {
    try {
      const systemSettings = await this.systemSettingsService.getSystemSettings();
      const search4toolId = systemSettings.search4toolId;

      if (environment.debugMode || search4toolId) {
        if (!this.hasView) {
          this.vcRef.createEmbeddedView(this.templateRef);
          this.hasView = true;
        }
      } else {
        this.vcRef.clear();
        this.hasView = false;
      }

    } catch (e) {
      throw e;
    }
  }
}
